import SyncIcon from '@/components/SynIcon/index.jsx';
import { memo } from 'react';
import isEqual from 'react-fast-compare';
import { Link } from 'react-router-dom';
import useExpenseAdd from '../../hooks/useExpenseAdd.js';

function Nav({
  onSync,
  showExtraBtn,
  planId,
}: {
  onSync: () => void;
  showExtraBtn?: boolean;
  planId: string;
}) {
  const expenseAddProps = useExpenseAdd({ planId });
  return (
    <div className=' sticky top-0  z-10  pt-safe bg-inherit'>
      <nav className='flex items-center justify-between text-xl h-[50px]  py-4 px-5'>
        <Link to='/'>
          <i className='ic-round md-close' />
        </Link>
        <div className='flex items-center'>
          {showExtraBtn && (
            <>
              <i
                {...expenseAddProps}
                className='ic-round md-attach_money select-none  hover:scale-70 transition-all  '
              />

              <i className='block mx-3 h-4 w-[1px] bg-black/10' />
            </>
          )}
          <SyncIcon onSync={onSync} />
          <i className='ic-outline md-settings' />
        </div>
      </nav>
    </div>
  );
}

export default memo(Nav, isEqual);
